<div class="text-size ">
    <div class="border p-2 text-center rounded-1 m-1">
        <div *ngIf="isEventAssigned">
            <div class="row">
                <div class="col-12 d-flex align-items-center">
                    <strong>{{eventdata?.name}}</strong><br>
                </div>
            </div>

            <div class="row">
                <div class="col-12 d-flex align-items-center">
                    <img src="./icon/blastMenu.svg" />
                    <span class="ms-1"> {{'VIBRATION.BLAST' | translate}}</span><br>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-6">
                    <button type="button" class="secondary-button"
                        (click)="modifyAssignedEvent()">
                        <img src="icon/edit-pencil.svg" /> <span >{{'BUTTONS.MODIFY' |
                            translate}}</span>
                    </button>
                </div>
                <div class="col-6">
                    <button type="button" class="tertiary-button" (click)="unassignRecord('event')">
                        <span >{{'BUTTONS.UNASSIGN' | translate}}</span>
                    </button>
                </div>
            </div>

        </div>
        <div *ngIf=" !isEventAssigned">
            <div class="p-2">
                <strong>{{(vibrationRecord.eventId === 0 || vibrationRecord.eventId === null) ? 'No Source' : 'ModifySource'}}</strong>
            </div>
            <app-autocomplete [options]="optionsEvents" [placeholder]="placeholderEvent"
                (optionSelected)="onOptionEventSelected($event)">
            </app-autocomplete>

            <button *ngIf="vibrationRecord.eventId !== 0 && vibrationRecord.eventId !== null" type="button"
                class="tertiary-button" (click)="cancel('event')">
                {{'BUTTONS.CANCEL' | translate}}
            </button>
            <button type="button" class="primary-button" (click)="assignRecord('event')">
                {{'BUTTONS.ASSIGN' | translate}}
            </button>

        </div>

    </div>
    <div class="border p-2 text-center rounded-1 m-1 mt-4">
        <div *ngIf="isControlPointAssigned ">
            <div class="row">
                <div class="col-12 d-flex align-items-center">
                    <strong> {{recordSite?.nom}} - {{vibrationRecord.controlPointName}}</strong><br>
                </div>
            </div>

            <div class="row">
                <div class="col-12 d-flex align-items-center">
                    <img src="./icon/control-point-black.svg" />
                    <span class="ms-1"> {{'NAVIGATION.MEASUREMENT_POINT' | translate}}</span><br>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-6">
                    <button type="button" class="secondary-button"
                        (click)="modifyAssignedCp()">
                        <img src="icon/edit-pencil.svg" /> <span
                            >{{'BUTTONS.MODIFY' |
                            translate}}</span>
                    </button>
                </div>
                <div class="col-6">
                    <button type="button" class="tertiary-button" (click)="unassignRecord('controlPoint')">
                        <span >{{'BUTTONS.UNASSIGN' | translate}}</span>
                    </button>
                </div>
            </div>

        </div>
        <div *ngIf="!isControlPointAssigned">

            <div class="p-2">
                <strong>{{(vibrationRecord.controlPointId === 0 || vibrationRecord.controlPointId === null) ?
                    'No measurement point' : 'Modify measurement point'}}</strong>
            </div>

            <!-- Site Selection -->
            <div class="mb-3 text-start">
                <label class="form-label fw-bold">{{ 'DEVICE.SITE' | translate }}</label>
                <app-autocomplete
                    [options]="optionsSites"
                    placeholder="{{ 'PLACEHOLDERS.SELECT_SITE' | translate }}"
                    (optionSelected)="onOptionSiteSelected($event)">
                </app-autocomplete>
            </div>

            <!-- Control Point Selection -->
            <div class="mb-3 text-start">
                <label class="form-label fw-bold">{{ 'DEVICE.CONTROL_POINT' | translate }}</label>
                <app-autocomplete
                    [options]="optionsControlPoints"
                    [placeholder]="placeholderCp"
                    (optionSelected)="onOptionCpSelected($event)">
                </app-autocomplete>
            </div>

            <button *ngIf="vibrationRecord.controlPointId !== 0 && vibrationRecord.controlPointId !== null"
                class="tertiary-button" (click)="cancel('controlPoint')">
                <span class="font-weight-600"> {{'BUTTONS.CANCEL' | translate}} </span>
            </button>

            <button class="primary-button" (click)="assignRecord('controlPoint')">
                <span class="font-weight-600"> {{'BUTTONS.ASSIGN' | translate}} </span>
            </button>
        </div>


    </div>

    <div class="border p-2 text-center m-1 rounded-1 mt-4">

        <div class="row">
            <div class="col-12 d-flex align-items-center">
                <strong> {{deviceRef}}</strong><br>
            </div>
        </div>

        <div class="row">
            <div class="col-12 d-flex align-items-center">
                <img src="./icon/device.svg" />
                <span class="ms-2 "> {{'DEVICE.LABEL' | translate}}</span><br>
            </div>
        </div>
    </div>
</div>